import { render, staticRenderFns } from "./AccountDisableHeader.vue?vue&type=template&id=0cb3b28a&scoped=true"
var script = {}
import style0 from "./AccountDisableHeader.vue?vue&type=style&index=0&id=0cb3b28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3b28a",
  null
  
)

export default component.exports